import { Component, OnDestroy } from "@angular/core";

@Component({
    templateUrl: './not-found.component.html'
})
export class NotFoundComponent  {
    
}


// WEBPACK FOOTER //
// ./src/app/components/not-found/not-found.component.ts